(() => {
	/* ------------------------------------------------------------------ *
	 *  Slide mode is now controlled from the theme editor
	 *  (section setting "Slide mode" → stepped | marquee), read per
	 *  section from the data-slide-mode attribute on the .swiper element.
	 * ------------------------------------------------------------------ */

	// Largest slidesPerView across all breakpoints below (1150: 6).
	// loop needs at least 2× slidesPerView real slides to build clones.
	const MAX_PER_VIEW = 6;
	const REQUIRED_SLIDES = MAX_PER_VIEW * 2; // 12

	/* Inject the linear-easing rule once (only affects .is-marquee sliders). */
	const ensureMarqueeStyles = () => {
		if (document.getElementById("logo-marquee-style")) return;
		const style = document.createElement("style");
		style.id = "logo-marquee-style";
		style.textContent =
			".logo-list__content--horizontal-carousel.is-marquee .swiper-wrapper" +
			"{transition-timing-function:linear !important;}";
		document.head.appendChild(style);
	};

	/* --------------------------------------------------------------- *
	 *  Duplicate real slides until there are enough for loop to clone.
	 *  Idempotent: safe to call on every resize / section reload.
	 * --------------------------------------------------------------- */
	const setSlides = (sliders) => {
		if (!sliders || sliders.length === 0) return;

		sliders.forEach((swiper) => {
			const wrapper = swiper.querySelector(".swiper-wrapper");
			if (!wrapper) return;

			// Remove anything we (or a previous Swiper loop) added before,
			// so we always measure against the true original set.
			wrapper
				.querySelectorAll('[data-logo-clone="true"], .swiper-slide-duplicate')
				.forEach((n) => n.remove());

			const originals = Array.from(
				wrapper.querySelectorAll(".logo-list__item")
			);
			if (originals.length === 0) return;

			let i = 0;
			while (
				wrapper.querySelectorAll(".logo-list__item").length < REQUIRED_SLIDES
			) {
				const clone = originals[i % originals.length].cloneNode(true);
				clone.setAttribute("data-logo-clone", "true");
				wrapper.appendChild(clone);
				i++;
			}
		});
	};

	const recalculateSlidesLength = () => {
		setSlides(document.querySelectorAll(".js-slider-logos"));
	};

	const initSlider = (section) => {
		let logosSlider;

		if (document.currentScript) {
			logosSlider =
				document.currentScript.parentElement.querySelectorAll(
					".js-slider-logos"
				);
		} else {
			logosSlider = section.querySelectorAll(".js-slider-logos");
		}

		if (!logosSlider || logosSlider.length === 0) return;

		logosSlider.forEach((el) => {
			const isHorizontal = el.classList.contains(
				"logo-list__content--horizontal-carousel"
			);

			// Read the mode chosen in the theme editor. Defaults to "stepped".
			const slideMode = el.getAttribute("data-slide-mode") || "stepped";

			// data-duration is the theme "speed" setting (ms) as a string.
			const rawDuration = Number(el.getAttribute("data-duration"));

			// Mode-specific autoplay + speed.
			let autoplay;
			let speed;

			if (slideMode === "marquee") {
				el.classList.add("is-marquee");
				autoplay = {
					delay: 0, // no pause between transitions = continuous
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				};
				// Long speed = slow crawl. Reuse the theme value if it's large,
				// otherwise fall back to a sensible crawl duration.
				speed = rawDuration >= 3000 ? rawDuration : 5000;
			} else {
				el.classList.remove("is-marquee");
				autoplay = {
					delay: 2500, // gap between steps
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				};
				speed = rawDuration > 0 ? rawDuration : 600; // transition length
			}

			new Swiper(el, {
				slidesPerView: isHorizontal ? 2 : 3,
				spaceBetween: 16,
				direction: "horizontal",
				loop: true, // was false — this is why nothing slid
				autoplay: autoplay, // was false — this too
				speed: speed, // now numeric, not a string
				shortSwipes: true,
				longSwipes: false,
				allowTouchMove: true,
				navigation: {
					nextEl: section.querySelector(".swiper-button-next"),
					prevEl: section.querySelector(".swiper-button-prev"),
				},
				breakpoints: {
					750: {
						slidesPerView: 3,
						spaceBetween: 16,
					},
					990: {
						slidesPerView: isHorizontal ? 4 : 3,
						spaceBetween: 20,
					},
					1150: {
						slidesPerView: isHorizontal ? 6 : 3,
						spaceBetween: 20,
					},
				},
				mousewheel: {
					forceToAxis: true,
				},
			});
		});
	};

	const initSection = (section) => {
		let sectionLogos;

		if (document.currentScript) {
			sectionLogos = document.currentScript.parentElement;
		} else {
			sectionLogos = section;
		}

		ensureMarqueeStyles();

		// Debounce resize handling: destroying + re-initing Swiper changes the
		// element size, which can re-trigger the observer. The timeout lets
		// layout settle before we rebuild.
		let resizeTimer;
		const sectionResizeObserver = new ResizeObserver((entries) => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				const [entry] = entries;
				const sliders = entry.target.querySelectorAll(".js-slider-logos");

				sliders.forEach((slider) => {
					if (slider.swiper) slider.swiper.destroy(true, true);
				});

				recalculateSlidesLength();
				initSlider(sectionLogos);
			}, 200);
		});

		recalculateSlidesLength();
		initSlider(sectionLogos);

		sectionResizeObserver.observe(sectionLogos);
	};

	initSection();

	document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
	});
})();